function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect, useCallback } from 'react';
var useSmartPanel = function useSmartPanel(buttonRef, panelRef, direction, align, spacer) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    newPanelRect = _useState2[0],
    setPanelRect = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    panelLeftPos = _useState4[0],
    setPanelLeftPos = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    panelTopPos = _useState6[0],
    setPanelTopPos = _useState6[1];
  var _useState7 = useState(direction),
    _useState8 = _slicedToArray(_useState7, 2),
    placement = _useState8[0],
    setDirection = _useState8[1];
  useEffect(function () {
    if (panelRef) {
      update();
    }
  }, [panelRef, update]);
  useEffect(function () {
    setDirection(direction);
  }, [direction]);
  var update = useCallback(function () {
    var buttonRect = buttonRef.current.getBoundingClientRect();
    var panelRect = panelRef.getBoundingClientRect();
    var scrollX = window.scrollX;
    var scrollY = window.scrollY;
    var topPos;
    var leftPos;

    // calculate topPos using getBoundingClientRect.top and window.scrollY
    if (placement === 'top') {
      leftPos = buttonRect.left + buttonRect.width / 2 - panelRect.width / 2;
      topPos = buttonRect.top - panelRect.height - spacer;
      if (leftPos <= 0) {
        leftPos = buttonRect.left;
      }
      if (leftPos + panelRect.width > window.innerWidth) {
        leftPos = buttonRect.left + buttonRect.width - panelRect.width;
      }
    } else if (placement === 'right') {
      leftPos = buttonRect.left + buttonRect.width + spacer;
      topPos = buttonRect.top + buttonRect.height / 2 - panelRect.height / 2;
      if (leftPos + panelRect.width > window.innerWidth) {
        setDirection('left');
      }
    } else if (placement === 'left') {
      leftPos = buttonRect.left - panelRect.width - spacer;
      topPos = buttonRect.top + buttonRect.height / 2 - panelRect.height / 2;
    } else if (placement === 'bottom') {
      leftPos = buttonRect.left + buttonRect.width / 2 - panelRect.width / 2;
      topPos = buttonRect.top + buttonRect.height + spacer;
      // flip align if panel width exceeds the window
      if (align === 'left') {
        if (panelRect.width > window.innerWidth - buttonRect.left) {
          leftPos = buttonRect.left + buttonRect.width - panelRect.width;
        } else {
          leftPos = buttonRect.left;
        }
      }
    }
    leftPos = leftPos + scrollX;
    topPos = topPos + scrollY;
    setPanelLeftPos(leftPos);
    setPanelTopPos(topPos);
    setPanelRect(panelRect);
  }, [buttonRef, panelRef, placement, spacer, align]);
  return {
    panelRect: newPanelRect,
    panelTopPos: panelTopPos,
    panelLeftPos: panelLeftPos,
    placement: placement
  };
};
export default useSmartPanel;